<div class="relative z-50 w-full max-w-[500px]" [@toastAnimation]="animationState()"
  (@toastAnimation.done)="onAnimationDone($event)">
  <div [class]="'rounded-lg flex w-full flex-col gap-2 content-between border-2 ' + theme.primary + ' ' + theme.border">
    <div class="w-full flex gap-2 items-center p-3">
      <div class="flex justify-start">
        <mg-icon iconClass="text-2xl h-fit w-fit" [iconName]="theme.icon"></mg-icon>
      </div>
      <div class="w-full">
        <div class="flex w-full items-center gap-1">
          <div class="w-full flex flex-col gap-1">
            <h2 class="font-semibold w-full text-base">{{label ? label : theme.title}}</h2>
            <div class="w-full text-sm" [innerHTML]="body"></div>
          </div>
          <button class="self-start" (click)="closeToast()">
            <mg-icon [iconClass]="'font-bold !text-sm'" iconName="close"></mg-icon>
          </button>
        </div>
        @if (labelCheck || toastData.redirectionButtom) {
        <div class="pt-1 w-full flex justify-between items-center">
          <div class="text-sm flex gap-2 items-center">
            @if(labelCheck){
            <input 
              type="checkbox" 
              class="toast_check" 
              [formControl]="formToast.get('isChecked') | formTransform:'formControl'"
              (change)="handleCheck($event)"
              [id]="'toast_check_'+typeToast"
            />
              }
            <span>{{labelCheck}}</span>
          </div>
          @if (toastData.redirectionButtom) {
          <div>
            <button [matTooltip]="'Ir a módulo'" (click)="showRedirect() ? handleRedirect() : null"
              [class]="'w-[30px] h-[30px] transition-all rounded-full hover:rotate-12 active:scale-75 ' + theme.secondary"
              [ngClass]="showRedirect() ? 'opacity-100' : 'opacity-50 cursor-not-allowed'">
              <mg-icon iconClass="h-fit w-fit text-sm" [iconName]="'arrow_outward'"></mg-icon>
            </button>
          </div>
          }
        </div>
        }
      </div>
    </div>
    @if (showProgressBar()) {
    <div id="progress_bar" [class]="'h-1 rounded-r-lg ' + theme.secondary" [style.width.%]="progressBar()">
    </div>
    }
    @if(toastData.dateCreation){
    <div class="text-xs text-right pr-2 pb-1">{{ toastData.dateCreation | date:'dd/MM/yyyy HH:mm' }}</div>
    }
  </div>
</div>